module.exports = "https://d3nn82uaxijpm6.cloudfront.net/packs/media/components/map/images/map-marker-range-end-080b61887bf0f0b73fc460f490057483.png";